import { cn } from '@/shared/utils/cn/cn.util';

import { type BrandMarkProps } from './BrandMark.types';
import { useBrandMarkLogic } from './useBrandMarkLogic';

/**
 * The brand's mark, wherever the shell shows who it is (P28).
 *
 * Sized by height and left to find its own width: a wordmark's aspect ratio is
 * the brand's to decide, and a fixed box with `object-contain` would centre a
 * wide mark inside dead space on either side.
 */
export function BrandMark({ size, className }: BrandMarkProps) {
  const { src, alt, onError } = useBrandMarkLogic();

  return (
    <img
      key={src}
      src={src}
      alt={alt}
      decoding="async"
      onError={onError}
      className={cn(
        'w-auto shrink-0 select-none',
        size === 'lg' ? 'h-brand-mark-lg' : 'h-brand-mark-sm',
        className,
      )}
    />
  );
}
